// extracted by mini-css-extract-plugin
export default {"price":"I5-z","onSale":"J5-z","msrpLabelPrice":"K5-z","msrpLabel":"L5-z","originalPrice":"M5-z","percentOff":"N5-z"};